// Configuração de variáveis de ambiente
export const ENV = {
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || 'https://jkmftolpmchsnxsjxoji.supabase.co',
  SUPABASE_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
} as const;

// Validação de variáveis críticas
if (!ENV.SUPABASE_KEY) {
  console.error('❌ VITE_SUPABASE_ANON_KEY não configurada! Crie um arquivo .env baseado em .env.example');
}

